import { Component, ViewEncapsulation } from '@angular/core';
import {LoadingService} from "../../_services/loading.service";

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoaderComponent {
  constructor(public loading: LoadingService ) {
  }

}
